/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Members_SearchInputs */

const cs_calendar_members_search = /** @type {(inputs: Calendar_Members_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat lidi`)
};

const en_calendar_members_search = /** @type {(inputs: Calendar_Members_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search people`)
};

/**
* | output |
* | --- |
* | "Search people" |
*
* @param {Calendar_Members_SearchInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_members_search = /** @type {((inputs?: Calendar_Members_SearchInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Members_SearchInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_members_search(inputs)
	return cs_calendar_members_search(inputs)
});